import { render, staticRenderFns } from "./bidding01.vue?vue&type=template&id=0cde0da3&scoped=true&"
import script from "./bidding01.vue?vue&type=script&lang=js&"
export * from "./bidding01.vue?vue&type=script&lang=js&"
import style0 from "./bidding01.vue?vue&type=style&index=0&id=0cde0da3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cde0da3",
  null
  
)

export default component.exports